export default {

    return: 'Volver',
    name: 'Nombre',
    preferredLanguage: 'Lenguaje de preferencia',
    languagePlaceHolder: 'Selecciona un lenguage',
    noLanguage: 'Lenguaje no encontrado',
    noLanguages: 'Lenguajes no encontrado',
    information: 'Información',
    description: 'Descripción',
    create: 'Crear',
    module: 'Módulo',
    actions: 'Acciones',
    activeText: 'Activo',
    inactiveText: 'Inactivo',
    details: 'Detalles',
    status: 'Estado',
    greeting: 'Hola, ',
    cancel: 'Cancelar',
    edit: 'Editar',
    address: 'Dirección',
    delete: 'Eliminar',
    category: 'Categoría',
    subcategory: 'Subcategoría',
    categoryPlaceHolder: 'Selecciona una categoría',
    subcategoryPlaceHolder: 'Selecciona una subcategoría',
    typePlaceHolder: 'Selecciona un tipo',
    noCategory: 'Categoría no encontrada',
    noCategories: 'Categorías no encontradas',
    noSubcategory: 'Subcategoría no encontrada',
    noSubcategories: 'Subcategorías no encontradas',
    warning: 'Advertencia',
    success: '¡Éxito!',
    unknown: 'Desconocido',
    genericError: 'Ha ocurrido un error al',
    update: 'actualizar',
    loadingLabel: 'Cargando Información...',
    enableEdit: 'Editar',
    editWarning: 'Debes habilitar para editar si quieres modificar este campo',
    confirmationMessage: '¿Está seguro que desea continuar?',
    addingMessage: 'Agregando...',
    deletingMessage: 'Borrando...',
    all: 'Todos',
    search: 'Buscar...',
    noOptions: 'No hay opciones',
    atention: '¡Atención!',
    level: 'Nivel',
    correctly: 'Correctamente',
    updated: 'Actualizado',
    created: 'Creado',
    save: 'Guardar',
    finalized: 'Finalizado',
    code: 'Código',
    start: 'Inicio',
    end: 'Fin',
    oups: '¡Ups!',
    new: 'Nuevo',
    one: 'Un',
    imReady: 'Estoy listo para continuar',
    index: 'Inicio',
    previous: 'Anterior',
    next: 'Siguiente',
    type: 'Tipo',
    clearFilter: 'Limpiar filtros',
    welcome: 'Bienvenido a Keru ',
    cleanFilters: 'Limpiar filtros',
    noStatuses: 'Estados no encontrados',
    followUps: 'Seguimientos',
    date: 'Fecha',
    selectFiles: 'Seleccionar archivos',
    see: 'Ver',
    filter: { single: 'Filtro', plural: 'Filtros' },
    applyFilter: 'Aplicar filtros',
    waitAlert: '¡Espera!',
    noPagePermissions: 'No tienes los permisos necesarios para acceder a esta página.',
    pageNotFound: 'La página que estás buscando no existe o ha sido eliminada.',
    notFoundAlert: '¡No encontrado!',
    noStatus: { single: 'Estado no encontrado', plural: 'Estados no encontrados' },
    welcomeMessage: 'Estamos encantados de tenerte en nuestra plataforma de <b>gestión de riesgos de seguridad de la información</b>. Aquí podrás administrar y proteger tu información de manera efectiva.',
    settings: 'Configuración',
    myAccount: 'Mi cuenta',
    logout: 'Cerrar sesión',
    notFound: '¡Ups! parece que la página que buscas no existe.',
    backHome: 'Volver al inicio',
    importCsvSuccess: 'Importación exitosa desde CSV',
    importCsvError: 'Error en la importación desde CSV',
    validating: 'Validando...',
    generating: 'Generando...',
    desactivating: 'Desactivando...',
    filters: 'Filtrar',
    importExcelSuccess: 'Importación exitosa desde excel',
    importExcelError: 'Error en la importación desde excel',
    importTemplate: 'Plantilla_de_Importacion',
    importCsv: 'Importar CSV',
    downloadTemplateCsv: 'Descargar plantilla de importación CSV',
    pagination: 'Página {current} de {total}',
    errorOccurred: 'Ha ocurrido un error',
    contactSupportWithCode: 'contacta con soporte con este código de error:',
    importExcel: 'Importar excel',
    downloadTemplateExcel: 'Descargar plantilla de importación excel',
    error: 'Error',
    page: 'Página',
    downloadErrors: 'Descargar errores',
    downloading: 'Descargando...',
    formErrors: 'Hay errores en el formulario, por favor corrígelos antes de continuar.',
    switchCompany: 'Cambiar organización',
    max500: 'Máximo 500 caracteres',
    configurationGuideMesage: 'En este módulo puedes gestionar la información base del sistema, incluyendo catálogos de vulnerabilidades y amenazas, tablas de configuración y valores de medidas para el análisis de riesgos.',

};
